<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2020-11-18 16:10:24
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/order/orderpay/components/Money/index.vue
-->
<template>
  <div class="mon">
    <div class=" font28 line_height_34 font_weight600 colof00">
      {{ getUserOrder.total | currency(false) }}
    </div>
    <!-- <div class="font12 font_weight400 colo087 line_height_14 time_mon">
      支付剩余时间：00:29:59
    </div> -->
    <!-- 待付款倒计时 -->
    <div
      v-if="getUserOrder.remainingTime"
      class="font12 font_weight400 colo087 line_height_14 time_mon"
    >
      <van-count-down :time="getUserOrder.remainingTime">
        <template v-slot="timeData">
          支付剩余时间：
          <span class="time_color">{{ timeData.hours || "00" }}:</span
          ><span class="time_color">{{ timeData.minutes || "00" }}:</span
          ><span class="time_color">{{ timeData.seconds }}</span>
        </template>
      </van-count-down>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  computed: {
    getUserOrder() {
      return this.$store.getters.getUserOrder;
    }
  }
};
</script>
<style lang="less" scoped>
.mon {
  padding: 20px 0;
  .time_mon {
    display: inline-block;
    margin-top: 12px;
    padding: 4px 16px;
    background: #f6f7f8;
    border-radius: 12px;
  }
}
</style>
